<template>
  <div class="add-asset">
    <div
      class="add-asset-btn"
      @click="handleLinkAsset"
    >
      ADD LINK ASSET
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia/dist/pinia';
import { useModalStore } from '@/store/ModalStore';

export default {
  name: 'AddAsset',
  computed: {
    ...mapStores(useModalStore)
  },
  methods: {
    handleLinkAsset () {
      // todo: insert hook to backend..
      this.modalStore.setModalObj({
        promptLabel: 'Add Asset Link',
        promptDescription: 'Enter a link to a YouTube video or PDF',
        showInput: true,
        buttonALabel: 'Cancel',
        buttonAFunc: this.cancelPrompt,
        buttonBLabel: 'CONFIRM',
        buttonBFunc: this.addAsset

      });
      this.modalStore.showModal('prompt');
    },
    addAsset () {

    },
    cancelPrompt () {
      this.modalStore.hideModal();
    }
  }
};
</script>

<style scoped>
.add-asset {
  display: flex;
  height: 30px;
}
.add-asset-btn {
  cursor: pointer;
  background-color: #72b9f3;
  color: white;
  width: 160px;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: .8em;
  font-weight: 900;
  letter-spacing: .07em;
  transition: background-color .2s;
}
.add-asset-btn:hover {
  background-color: #58a0da;
}
</style>